<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商品分组
      <small>
        /&nbsp;
        <router-link to="/grouporderlist" class="TitleStyle">分组列表</router-link>
        /&nbsp;
        分组报价/&nbsp;详情
      </small>
    </h1>
    <!-- end col-6 -->
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">列表详情</h4>
              </div>
              <!-- end panel-heading -->
              <div class="OrderInfo">
                <div class="OrderGroup">
                  <div class="GTitle">
                    <!--  <span class="TInfo">仓库详情</span>-->
                  </div>
                  <div class="GContent">
                    <ul class="GContentUl">  
                      <li class="TableContent">
                        <span class="TCode">分组名：</span>
                        <span
                          class="TCodeContent"
                        >{{orderdetail.groupName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">商品编号：</span>
                        <span class="TCodeContent">{{orderdetail.goodsCode}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">商品名称：</span>
                        <span class="TCodeContent">{{orderdetail.goodsName}}</span>
                      </li>
                     
                   
                      <li class="TableContent">
                        <span class="TCode">单位：</span>
                        <span class="TCodeContent">{{orderdetail.unit}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">品牌：</span>
                        <span class="TCodeContent">{{orderdetail.brandName}}</span>
                      </li>
                     <li class="TableContent">
                        <span class="TCode">系列：</span>
                        <span class="TCodeContent">{{orderdetail.seriesName}}</span>
                      </li>
                      <li class="TableContent">
                        <span class="TCode">包装率：</span>
                        <span class="TCodeContent">{{orderdetail.packagerates}}</span>
                      </li>

                      <li class="TableContent">
                        <span class="TCode">操作人：</span>
                        <span class="TCodeContent">{{orderdetail.updater}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">操作时间：</span>
                        <span class="TCodeContent">{{orderdetail.updateTime}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">状态：</span>
                        <span class="TCodeContent">{{orderdetail.currentstatus}}</span>
                      </li>
                        <li class="TableContent">
                        <span class="TCode">零售价：</span>
                        <span class="TCodeContent">{{orderdetail.advicePrice}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">供货价：</span>
                        <span class="TCodeContent">{{orderdetail.quotedprice}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">是否包邮：</span>
                        <span class="TCodeContent">{{orderdetail.isfee}}</span>
                      </li>
                       <li class="TableContent">
                        <span class="TCode">运费：</span>
                        <span class="TCodeContent">{{orderdetail.expresses}}</span>
                      </li>
                      <li class="clear"></li>
                    </ul>
                  </div>  
                    <div style="height:46px;padding-top:16px;">
                       <a  class="btn btn-primary m-r-5 BackButton" @click="GoBack" >返&nbsp;&nbsp;回</a>
                      
                        <span class="clear"></span>
                  </div>
                </div>
              </div>
            </div>
            <!-- end panel -->
          </div>     
     
          <!-- end col-10 -->
        </div>    
  
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>

  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "@/common/http";

export default {
  name: "PackDetail",
  data() {
    return {
     pageNo:1,
     pageSize:10,
     packageratesId:'',
     orderdetail:[],
     row:[],
     groupId:"",
     searchContent:{},
     firstSearchContent:{},
     firstpageSize: 10,
     firstpageIndex: 1
    };
  },
  mounted: function() {
         if(this.$route.query){
          this.firstSearchContent = JSON.parse(this.$route.query.firstSearchContent);
          this.firstpageSize = this.$route.query.firstpageSize;
          this.firstpageIndex = this.$route.query.firstpageIndex; 
          this.searchContent =  JSON.parse(this.$route.query.searchContent);
         
        }
   this.initdata()
  },
  methods: {
    initdata() {
     let that = this;
     if(localStorage.getItem('goodlists')){
       let goodlists =localStorage.getItem('goodlists')
       this.row = JSON.parse(goodlists).row;
       this.groupId = this.row.groupId;
       this.pageNo = JSON.parse(goodlists).pageNo;
       this.pageSize = JSON.parse(goodlists).pageSize;
      
     
        const options = {
        url: "distribution/B2cGoodsPackageRates/queryPackageratesDetail",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          packageratesId: that.row.packageratesId
        })
      };
      axios(options)
        .then(function(response) {

          if (response.data.code == 200) {

           console.log(209,response.data.data)
            that.orderdetail = response.data.data;
            if(that.orderdetail.status === 1){
              that.orderdetail.currentstatus = '正常'
            }else if( that.orderdetail.status === 0){
              that.orderdetail.currentstatus = '删除'
            }
            if(that.orderdetail.isFee === 0){
                that.orderdetail.isfee  ='是'
            }else if(that.orderdetail.isFee === 1){
              that.orderdetail.isfee  = '否'
            }
           
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(error => {
          http.handleHttpError(error, that);
        });
    }
    },
    GoBack(){
   
       this.$router.push({ name: "PackManagement" , 
       params: { pageNo : this.pageNo, pagesize:this.pageSize, searchContent:JSON.stringify(this.searchContent)},
       query: { groupId: this.groupId, firstpageSize: this.firstpageSize, firstpageIndex: this.firstpageIndex, firstSearchContent: JSON.stringify(this.firstSearchContent)}
       });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ModelPadding {
  margin-top: -30px;
}
.LineSpacing {
  margin-top: 16px;
}
.ButtonColor {
  color: #fff !important;
}

.OrderInfo {
  padding: 20px 30px;
}
.GTitle {
  border-top: 3px #84caf3 solid;
  overflow: hidden;
  line-height: 25px;
  border-right: 1px #e5e5e5 solid;
  background: #f4f4f4;
}
.TInfo {
  position: relative;
  min-width: 130px;
  float: left;
  font-size: 16px;
  padding: 5px 15px;
  background-color: #84caf3;
  color: #ffffff;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}

.TitleStyle {
  color: #6a7786;
}
@media screen and (min-width:1360px) and (max-width:1680px){ /*二栏布局*/ .TableContent{width: 50%;}  }
@media screen and (min-width:1680px) and (max-width:2000px){ /*二栏布局*/ .TableContent{width: calc(100%/3);}  }
.TableContent {
  float: left;
}
.GContentUl {
  list-style: none;
}
.TCode {
  color: #999999;
  text-align: left;
  display: inline-block;
  width: 105px;
  overflow: hidden;
  font-size: 14px;
  float: left;
  padding-left: 16px;
  padding-top:8px;
  padding-bottom: 8px;
}
.TCodeContent {
  font-size: 12px;
  float: left;
  width: calc(100% - 105px);
  line-height: 20px;
  text-align: left;
  word-break: normal;
  word-wrap: break-word;
  padding-top:8px;
  padding-bottom: 8px;
}
.BackButton{
  float:right;
  cursor:pointer;
  color:#fff !important
}
</style>



// WEBPACK FOOTER //
// src/components/GroupManage/PackDetail.vue